export const APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_REQUESTED =
    'APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_REQUESTED';
export const APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_SUCCEEDED =
    'APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_SUCCEEDED';
export const APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_FAILED =
    'APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_FAILED';
export const APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_CANCELED =
    'APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_CANCELED';
export const APPLIED_FERTILIZER_ENTITIES_BY_DATE_SET =
    'APPLIED_FERTILIZER_ENTITIES_BY_DATE_SET';

export const APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE =
    'APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD';
